export default __webpack_public_path__ + "static/media/a011-fsi-05.1c38c61d.svg";